"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopNavigationBar = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var classNames = require("classnames");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var viewport_1 = require("../../reducers/viewport");
var Icon_1 = require("components/Icon");
var avatars_1 = require("../../components/Avatar/avatars");
require("./style.scss");
var translate_1 = require("utils/translate");
var LanguageSelector_1 = require("components/LanguageSelector");
var utils_1 = require("./utils");
var defaultAvatar = (0, avatars_1.getAvatar)(0);
var TopNavigationBar = function () {
    var selectedLanguageCode = (0, translate_1.getLanguage)() || 'en';
    var states = (0, react_redux_1.useSelector)(function (state) {
        var _a, _b, _c;
        return ({
            size: state.viewport.size,
            isMobile: (0, viewport_1.isMobile)(state.viewport),
            pathname: state.router.location.pathname,
            user: state.auth.current.user,
            cartItemsCount: state.cart.data.items.length,
            cartItems: state.cart.data.items,
            token: state.auth.zendesk.token,
            translations: state.translations,
            rootId: ((_a = state.project.currentProject.root) === null || _a === void 0 ? void 0 : _a.id) || ((_b = state.bid.current.bid) === null || _b === void 0 ? void 0 : _b.id),
            currentBidName: (_c = state.bid.current.bid) === null || _c === void 0 ? void 0 : _c.name
        });
    });
    var _a = React.useState(null), zendesk = _a[0], setZendesk = _a[1];
    var dispatch = (0, react_redux_1.useDispatch)();
    var dispatchProps = React.useMemo(function () { return (0, utils_1.mapDispatchToProps)(dispatch); }, [dispatch]);
    var combinedProps = React.useMemo(function () { return (__assign(__assign(__assign({}, states), dispatchProps), { zendesk: zendesk, setZendesk: setZendesk })); }, [states, dispatchProps, zendesk, setZendesk]);
    React.useEffect(function () {
        if (combinedProps.zendesk && combinedProps.token !== '') {
            var url = "https://sokopro.zendesk.com/access/jwt?jwt=".concat(combinedProps.token, "&return_to=https://sokopro.zendesk.com/");
            combinedProps.zendesk.location.href = url;
            combinedProps.zendesk.focus();
            combinedProps.setZendesk(null);
            combinedProps.clearToken();
        }
    }, [combinedProps.zendesk, combinedProps.token]);
    var avatar = combinedProps.user
        .map(function (user) { return (0, avatars_1.getAvatarUrl)(user.avatar); })
        .getOrElse(defaultAvatar);
    var openCart = function () {
        dispatchProps.toggleCart();
        if (states.cartItemsCount > 0) {
            var cartPaths = states.cartItems.map(function (item) { return item.path; });
            var sanitizePath_1 = function (path) {
                if (!path || !states.currentBidName)
                    return path;
                var index = path.indexOf(states.currentBidName);
                return index !== -1 ? path.substring(index) : path;
            };
            var sanitizedPaths_1 = cartPaths.map(sanitizePath_1);
            var filteredItems = states.cartItems
                .filter(function (item) {
                var sanitizedItemPath = sanitizePath_1(item.path);
                return sanitizedPaths_1.some(function (parentPath) {
                    return parentPath !== sanitizedItemPath &&
                        sanitizedItemPath.startsWith(parentPath);
                });
            })
                .map(function (item) { return item.id; });
            if (filteredItems.length > 0 && states.rootId) {
                dispatchProps.onRemoveItemFormCart(states.rootId)(filteredItems);
                dispatchProps.showCartInfoText(true);
            }
        }
    };
    return (React.createElement(sok_ui_1.NavigationBar, { toggleNavigationMenu: combinedProps.isMobile
            ? combinedProps.toggleNavigationMenu
            : combinedProps.toggleNavigationMenuWidth },
        React.createElement("div", { className: 'sok-left-top-corner-navigation-menu' },
            React.createElement(react_router_dom_1.Link, { className: 'logo-with-text', to: "/".concat(selectedLanguageCode) },
                React.createElement("div", null,
                    React.createElement("img", { src: __SOKOBID_PORTAL__
                            ? '/assets/images/SokoBid_logo.svg'
                            : '/assets/images/SokoPro_logo.svg', width: '1126', height: '146.53' }),
                    __SOKOBID_PORTAL__ && (React.createElement("span", null,
                        "- ",
                        (0, translation_1.getLocalization)('topNavigation/sokobidPortalTitle')))))),
        React.createElement("div", { className: 'sok-center-top-corner-navigation-menu' }),
        React.createElement("div", { className: 'sok-right-top-corner-navigation-menu' },
            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('topNavigation/changeLanguage')) },
                React.createElement(LanguageSelector_1.default, { isMobile: combinedProps.size === 'MOBILE', languageCode: selectedLanguageCode, updateUserLanguage: combinedProps.updateUserLanguage })),
            (combinedProps.pathname.includes('documents') ||
                combinedProps.pathname.match(/^\/([\w]+)\/projects\/([\d]+).*/) ||
                combinedProps.pathname.match(/\/bid\/\d*\/letters\/\d*/) ||
                combinedProps.pathname.match(/^\/([\w]+)\/bid\/([\d]+).*/)) && (React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('topNavigation/shoppingcart')) },
                React.createElement("div", { className: classNames('shopping-cart', combinedProps.cartItemsCount > 0 && 'has-badge'), onClick: openCart, "data-count": combinedProps.cartItemsCount > 99
                        ? '+99'
                        : combinedProps.cartItemsCount.toString() },
                    React.createElement(Icon_1.Icon, { className: "fa-shopping-cart" })))),
            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('topNavigation/dropdown/settings')) },
                React.createElement(sok_ui_1.Dropdown2, { className: "user-settings-dropdown", alignment: "right" },
                    React.createElement("div", { className: "avatar-wrap" },
                        React.createElement("img", { src: avatar, className: 'avatar-icon', width: 200, height: 200 }),
                        React.createElement(Icon_1.Icon, { className: "fa-angle-down" })),
                    React.createElement(sok_ui_1.Dropdown2Menu, null,
                        React.createElement(sok_ui_1.Dropdown2MenuItem, null,
                            React.createElement("span", { id: "user-settings-button", onClick: function () {
                                    return combinedProps.user.fold(null, combinedProps.openUserSettingsModal);
                                } },
                                React.createElement(Icon_1.Icon, { className: "fa-cog fa-fw" }),
                                ' ',
                                (0, translation_1.getLocalization)('topNavigation/dropdown/settings'))),
                        React.createElement(sok_ui_1.Dropdown2MenuItem, null,
                            React.createElement("span", { id: "tutorials-button", onClick: function () {
                                    combinedProps.setZendesk(window.open('about:blank', 'blank'));
                                    combinedProps.zendeskToken();
                                } },
                                React.createElement(Icon_1.Icon, { className: "fa-book fa-fw" }),
                                ' ',
                                (0, translation_1.getLocalization)('topNavigation/dropdown/tutorials'))),
                        React.createElement(sok_ui_1.Dropdown2MenuItem, null,
                            React.createElement("span", { id: "logout-button", onClick: function () { return combinedProps.logout(); } },
                                React.createElement(Icon_1.Icon, { className: "fa-sign-out fa-fw" }),
                                ' ',
                                (0, translation_1.getLocalization)('topNavigation/dropdown/logout')))))))));
};
exports.TopNavigationBar = TopNavigationBar;
